"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.delete.confirm.title': 'Usuń Branżę',
    'branch.delete.confirm.message': 'Czy na pewno chcesz usunąć tę branżę?',
};
